function numbersToWords(num: number): string {
    const units = [
        "",
        "SATU",
        "DUA",
        "TIGA",
        "EMPAT",
        "LIMA",
        "ENAM",
        "TUJUH",
        "DELAPAN",
        "SEMBILAN",
    ];
    const scales = ["", "RIBU", "JUTA", "MILYAR", "TRILIUN"];

    if (num === 0) return "NOL RUPIAH";
    if (num < 0) return `MINUS ${numbersToWords(Math.abs(num))}`;

    let words = "";

    for (let i = 0; i < scales.length; i++) {
        const scaleValue = Math.floor(num / 1000 ** i) % 1000;
        if (scaleValue !== 0) {
            let scaleWords = "";
            const hundreds = Math.floor(scaleValue / 100);
            const tens = Math.floor((scaleValue % 100) / 10);
            const ones = scaleValue % 10;

            if (hundreds > 0) {
                scaleWords += `${units[hundreds]} RATUS `;
            }

            if (tens === 1) {
                if (ones === 0) {
                    scaleWords += "SEPULUH ";
                } else if (ones === 1) {
                    scaleWords += "SEBELAS ";
                } else {
                    scaleWords += `${units[ones]} BELAS `;
                }
            } else if (tens > 1) {
                scaleWords += `${units[tens]} PULUH `;
            }

            if (tens !== 1 && ones > 0) {
                scaleWords += `${units[ones]} `;
            }

            scaleWords = scaleWords.trim();
            if (scaleWords !== "") {
                scaleWords += ` ${scales[i]} `;
            }

            words = scaleWords + words;
        }
    }

    words = words.trim();
    if (words === "SATU RIBU") {
        words = "SERIBU";
    }

    return `${words} RUPIAH`;
}

export { numbersToWords };
